import { connect } from 'react-redux';
import LaporanGuru from '../../views/Settings/LaporanGuru.view';
import {
  getParamOptionsAcademics, getClassesOptions, getPeriodsOptions, getPrmLevels, getSchoolUnitsOptions, getParamPerwakilan,
} from '../../states/thunks/options.thunk';
import {
  reportStaffMapel, studentCount, reportStaffMapelPerwakilan, reportStaffMapelPerunit,
  reportStaffTeacher, reportStaffTeacherPerwakilan, reportStaffTeacherPerunit
} from '../../states/thunks/academics.thunk';


function mapStateToProps(state) {
  return {
    classes: state.options.classes,
    levels: state.options.levels,
    user: state.user || {},

  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleStudentCount: payload => dispatch(studentCount(payload)),
    getClassesOptions: payload => dispatch(getClassesOptions(payload)),
    getParamOptionsAcademics: (payload, type) => dispatch(getParamOptionsAcademics(payload, type)),
    handleReportStaffMapel: (payload, goback) => dispatch(reportStaffMapel(payload, goback)),
    handleReportStaffMapelPerwakilan: (payload, goback) => dispatch(reportStaffMapelPerwakilan(payload, goback)),
    handleReportStaffMapelPerunit: (payload, goback) => dispatch(reportStaffMapelPerunit(payload, goback)),
    handleReportStaffTeacher: (payload, goback) => dispatch(reportStaffTeacher(payload, goback)),
    handleReportStaffTeacherPerwakilan: (payload, goback) => dispatch(reportStaffTeacherPerwakilan(payload, goback)),
    handleReportStaffTeacherPerunit: (payload, goback) => dispatch(reportStaffTeacherPerunit(payload, goback)),
    getPeriodsOptions: payload => dispatch(getPeriodsOptions(payload)),
    getPrmLevels: payload => dispatch(getPrmLevels(payload)),
    getSchoolUnitsOptions: payload => dispatch(getSchoolUnitsOptions(payload)),
    getParamPerwakilan: payload => dispatch(getParamPerwakilan(payload)),

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LaporanGuru);
